<template>
  <section class="section container pt-0">
    <requests-datatable />
  </section>
</template>

<script>
import RequestsDatatable from "./requests_datatable/Index.vue";

export default {
  name: "SIRCIndex",
  components: {
    RequestsDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
